<template>
  <div class="rect__title">
    <h1>
      {{ formatDateRange(currentPeriod[0], currentPeriod[1]) }}
    </h1>
    <Controls
      :currentPeriod="currentPeriod"
      :lastValues="lastValues"
      @setCurrentPeriod="setCurrentPeriod"
      :key="currentPeriod[0].getTime() + currentPeriod[1].getTime()"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import Controls from '../analytics/Controls.vue'
import ItemToggle from '@/components/helpers/ItemToggle.vue'
import { months } from '@common/constants/time.constant'

@Component({
  components: { ItemToggle, Controls }
})
export default class StatisticsTimeSelector extends Vue {
  private currentPeriod = [new Date(), new Date()]

  @Prop({ default: false }) readonly isEnabled: boolean
  @Prop({ default: () => ({}) }) readonly lastValues: {month: number, year: number}

  async setCurrentPeriod(period: Date[]) {
    this.currentPeriod = period
    this.$emit('update:currentPeriod', period)
  }

  currentPeriodText(date: Date) {
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`
  }

  formatDateRange(startDate: Date, endDate: Date) {
    const isSameDay = (d1, d2) =>
      d1.getDate() === d2.getDate() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getFullYear() === d2.getFullYear();

    const isStartOfMonth = (date) => date.getDate() === 1;

    const isEndOfMonth = (date) =>
      new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate() === date.getDate();

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    startDate = new Date(startDate);
    endDate = new Date(endDate);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    if (isSameDay(startDate, endDate)) {
      if (isSameDay(startDate, today)) return "Today";
      if (isSameDay(startDate, yesterday)) return "Yesterday";
      return `${startDate.getDate()} ${months[startDate.getMonth()]} ${startDate.getFullYear()}`;
    }

    if (isStartOfMonth(startDate) && isSameDay(endDate, today)) {
      return "This month";
    }

    if (isStartOfMonth(startDate) && isEndOfMonth(endDate) &&
      startDate.getMonth() === endDate.getMonth() &&
      startDate.getFullYear() === endDate.getFullYear()) {
      return `${months[startDate.getMonth()]} ${startDate.getFullYear()}`;
    }

    return `${startDate.getDate()} ${months[startDate.getMonth()]} ${startDate.getFullYear()} - ${endDate.getDate()} ${months[endDate.getMonth()]} ${endDate.getFullYear()}`;
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.rect {

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .container__date-wrapper + h1 {
      margin-left: 20px;
    }
  }
}

.rect__title {
  color: white;
}

h1 {
  font-size: 28px;
  font-weight: 700;
  color: white;
  line-height: 36px;
  margin: 0;

  span {
    font-size: 14px;
  }
}
</style>
